import { useState } from 'react';
import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  const [avatarErrors, setAvatarErrors] = useState<Record<number, boolean>>({});

  const handleAvatarError = (idx: number) => {
    setAvatarErrors((prev) => ({ ...prev, [idx]: true }));
  };

  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            网友热评
          </h2>
          <p className="text-sm text-foreground-500">瓜友们都在聊什么？看看大家的精彩点评</p>
        </div>

        <div className="max-w-[900px] mx-auto space-y-4">
          {commentItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-background-200 overflow-hidden shrink-0">
                  {!avatarErrors[i] ? (
                    <img
                      src={item.avatar}
                      alt={item.nickname}
                      className="w-full h-full object-cover"
                      onError={() => handleAvatarError(i)}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <i className="ri-user-line text-foreground-400"></i>
                    </div>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="font-medium text-sm text-foreground-900">{item.nickname}</span>
                    <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium text-white ${item.badgeColor}`}>
                      {item.badge}
                    </span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-2">{item.content}</p>
                  <div className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-thumb-up-line"></i>
                    <span>{item.likes.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}